import type { TypedSupabaseClient } from '../client';
import type { IProFavoriteRepository, ProFavorite } from '../../../interfaces/src';

export class SupabaseProFavoriteRepository implements IProFavoriteRepository {
  constructor(private supabase: TypedSupabaseClient) {}

  async list(): Promise<ProFavorite[]> {
    const { data, error } = await (this.supabase as any)
      .from('pro_favorites')
      .select('*');
    if (error) throw error;
    return ((data ?? []) as Array<Record<string, unknown>>).map(mapFavorite);
  }

  async add(articleId: string): Promise<ProFavorite> {
    const proId = await currentProCustomerId(this.supabase);
    const { data, error } = await (this.supabase as any)
      .from('pro_favorites')
      .upsert({ pro_customer_id: proId, article_id: articleId })
      .select()
      .single();
    if (error) throw error;
    return mapFavorite(data);
  }

  async remove(articleId: string): Promise<void> {
    const proId = await currentProCustomerId(this.supabase);
    const { error } = await (this.supabase as any)
      .from('pro_favorites')
      .delete()
      .eq('pro_customer_id', proId)
      .eq('article_id', articleId);
    if (error) throw error;
  }
}

async function currentProCustomerId(client: TypedSupabaseClient): Promise<string> {
  const { data: userData } = await client.auth.getUser();
  const userId = userData.user?.id;
  if (!userId) throw new Error('Not authenticated');
  const { data, error } = await (client as any)
    .from('pro_customers')
    .select('id')
    .eq('user_id', userId)
    .maybeSingle();
  if (error) throw error;
  if (!data) throw new Error('Aucun profil pro');
  return data['id'] as string;
}

function mapFavorite(row: Record<string, unknown>): ProFavorite {
  return {
    proCustomerId: row['pro_customer_id'] as string,
    articleId: row['article_id'] as string,
    createdAt: row['created_at'] as string,
  };
}
